import React from 'react';
import { Form as FinalForm } from 'react-final-form';
import { required } from '../../util/validators';
import {
    FieldRadioButton,
    SecondaryButton,
    Form,
    FieldCheckbox,
    FieldTextInput,
    FieldDateInput,
    FieldSelect,
} from '../../components';
import css from './AdminPageFlipAndWin.css';

export default ({ onSubmit, initialValues = {}, action, ready, inProgress }) => (
    <FinalForm
        keepDirtyOnReinitialize
        onSubmit={onSubmit}
        initialValues={initialValues}
        render={fieldRenderProps => {
            const { handleSubmit, values, form } = fieldRenderProps;
            const {
                type,
                priority,
                teaserText,
                countries,
                logo,
                probability,
                title,
                voucherCode,
                voucherLink,
                amount,
                isHighValue,
                excludePrevWinners,
            } = values || {};

            const isCredits = type === 'credits';
            const isCoupon = type === 'coupon';
            const isProduct = type === 'product';

            const disabled =
                !type ||
                !logo ||
                !countries ||
                countries.length === 0 ||
                !title ||
                typeof probability === 'undefined' ||
                typeof priority === 'undefined' ||
                !teaserText ||
                (isCredits ? !amount : false) ||
                (isCoupon ? !voucherCode : false) ||
                (isProduct ? !voucherLink : false);

            return (
                <Form onSubmit={handleSubmit} className={css.form}>
                    <div>
                        <p>Typ</p>
                        <FieldRadioButton
                            form={form}
                            id="credits"
                            name="type"
                            label="Credits"
                            value="credits"
                        />
                        <FieldRadioButton
                            form={form}
                            id="coupon"
                            name="type"
                            label="Coupon"
                            value="coupon"
                        />
                        <FieldRadioButton
                            form={form}
                            id="product"
                            name="type"
                            label="Product"
                            value="product"
                        />
                    </div>
                    <div>
                        <p>Land</p>
                        <FieldCheckbox
                            type="checkbox"
                            id="CH"
                            name="countries"
                            label="Schweiz"
                            value="CH"
                            form={form}
                        />
                        <FieldCheckbox
                            type="checkbox"
                            id="DE"
                            name="countries"
                            label="Deutschland"
                            value="DE"
                            form={form}
                        />
                    </div>
                    <div>
                        <p>Rolle</p>
                        <FieldCheckbox
                            type="checkbox"
                            id="horseowner"
                            name="userType"
                            label="Horseowner"
                            value="horseowner"
                            form={form}
                        />
                        <FieldCheckbox
                            type="checkbox"
                            id="rider"
                            name="userType"
                            label="Rider"
                            value="rider"
                            form={form}
                        />
                        <FieldCheckbox
                            type="checkbox"
                            id="administrator"
                            name="userType"
                            label="Admin"
                            value="administrator"
                            form={form}
                        />
                    </div>
                    <div>
                        <p>Parameter ・Optional</p>
                        <FieldCheckbox
                            type="checkbox"
                            id="withParams"
                            name="withParams"
                            label="uuid, city, postal code, etc"
                            form={form}
                        />
                    </div>
                    <div>
                        <p>Logo</p>
                        <FieldTextInput
                            type="text"
                            id="logo"
                            name="logo"
                            placeholder="https://"
                            validate={required('This field is required')}
                        />
                    </div>
                    <div>
                        <p>Gewinnchance</p>
                        <FieldTextInput
                            type="number"
                            id="probability"
                            name="probability"
                            placeholder="10,20,30"
                            validate={required('This field is required')}
                        />
                    </div>
                    {!excludePrevWinners && (
                        <div>
                            <p>Hoher Wert・Optional</p>
                            <FieldCheckbox
                                type="checkbox"
                                id="isHighValue"
                                name="isHighValue"
                                label="Hoher Wert"
                                form={form}
                            />
                        </div>
                    )}
                    {isHighValue && (
                        <div>
                            <p>Sperrfrist (Tage)・Optional</p>
                            <FieldTextInput
                                type="number"
                                id="lockPeriod"
                                name="lockPeriod"
                                placeholder="E.g. 60 (used as filter)"
                            />
                        </div>
                    )}
                    {!isHighValue && (
                        <div>
                            <p>Ausschlüsse・Optional</p>
                            <FieldCheckbox
                                type="checkbox"
                                id="excludePrevWinners"
                                name="excludePrevWinners"
                                label="Gewinner ausschliessen (used as filter)"
                                form={form}
                            />
                        </div>
                    )}
                    <div>
                        <p>Priorität</p>
                        <FieldTextInput
                            type="number"
                            id="priority"
                            name="priority"
                            placeholder="10,20,30"
                            validate={required('This field is required')}
                        />
                    </div>
                    <div>
                        <p>Titel</p>
                        <FieldTextInput
                            type="text"
                            id="title"
                            name="title"
                            placeholder="Title"
                            validate={required('This field is required')}
                        />
                    </div>
                    <div>
                        <p>Teaser</p>
                        <FieldTextInput
                            type="textarea"
                            id="teaserText"
                            name="teaserText"
                            placeholder="Teaser Text"
                            validate={required('This field is required')}
                        />
                    </div>
                    {isCredits && (
                        <div>
                            <p>Credits</p>
                            <FieldTextInput
                                type="number"
                                id="amount"
                                name="amount"
                                placeholder="10,20,30"
                                validate={required('This field is required')}
                            />
                        </div>
                    )}
                    {isCredits && (
                        <div>
                            <p>Illustration</p>
                            <FieldSelect
                                id="illustration"
                                name="illustration"
                                placeholder="Gewinn XXL"
                                form={form}
                                validate={required('This field is required')}
                                className={css.fieldSelectPageFour}
                                optionsList={['xs', 's', 'm', 'l', 'xl', 'xxl'].map(option => ({
                                    value: `gewinn-${option}`,
                                    label: `Gewinn ${option.toUpperCase()}`,
                                }))}
                            />
                        </div>
                    )}
                    {isCoupon && (
                        <div>
                            <p>Code</p>
                            <FieldTextInput
                                type="text"
                                id="voucherCode"
                                name="voucherCode"
                                placeholder="E.i. HORSEDEAL10"
                                validate={required('This field is required')}
                            />
                        </div>
                    )}
                    {isProduct && (
                        <div>
                            <p>Link</p>
                            <FieldTextInput
                                type="text"
                                id="voucherLink"
                                name="voucherLink"
                                placeholder="E.i. https://www.horsedeal.com"
                                validate={required('This field is required')}
                            />
                        </div>
                    )}
                    <div>
                        <p>Bestand ・Optional</p>
                        <FieldTextInput
                            type="number"
                            id="inStock"
                            name="inStock"
                            placeholder="E.g. 100"
                        />
                    </div>
                    <div>
                        <p>Enddatum ・Optional</p>
                        <FieldDateInput name="endDate" id="endDate" placeholder="E.g. 31.12.2025" />
                    </div>
                    <div>
                        <p>Gewinn des Monats・Optional</p>
                        <FieldCheckbox
                            type="checkbox"
                            id="monthPrize"
                            name="monthPrize"
                            label="Yes"
                            form={form}
                        />
                    </div>
                    <div>
                        <p>Dialog Akk. 1 ・Optional</p>
                        <FieldTextInput
                            type="text"
                            id="dialogAcc1"
                            name="dialogAcc1"
                            placeholder="Dialog Akk. 1"
                        />
                    </div>
                    <div>
                        <p>Dialog Text 1 ・Optional</p>
                        <FieldTextInput
                            type="textarea"
                            id="dialogText1"
                            name="dialogText1"
                            placeholder="Dialog Text 1"
                        />
                    </div>
                    <div>
                        <p>Dialog Akk. 2 ・Optional</p>
                        <FieldTextInput
                            type="text"
                            id="dialogAcc2"
                            name="dialogAcc2"
                            placeholder="Dialog Akk. 2"
                        />
                    </div>
                    <div>
                        <p>Dialog Text 2 ・Optional</p>
                        <FieldTextInput
                            type="textarea"
                            id="dialogText2"
                            name="dialogText2"
                            placeholder="Dialog Text 2"
                        />
                    </div>
                    <div>
                        <p>Dialog Akk. 3 ・Optional</p>
                        <FieldTextInput
                            type="text"
                            id="dialogAcc4"
                            name="dialogAcc4"
                            placeholder="Dialog Akk. 3"
                        />
                    </div>
                    <div>
                        <p>Dialog Text 3 ・Optional</p>
                        <FieldTextInput
                            type="textarea"
                            id="dialogText4"
                            name="dialogText4"
                            placeholder="Dialog Text 3"
                        />
                    </div>
                    <div>
                        <p>Dialog Akk. 4 ・Optional</p>
                        <FieldTextInput
                            type="text"
                            id="dialogAcc3"
                            name="dialogAcc3"
                            placeholder="Dialog Akk. 4"
                        />
                    </div>
                    <div>
                        <p>Dialog Text 4 ・Optional</p>
                        <FieldTextInput
                            type="textarea"
                            id="dialogText3"
                            name="dialogText3"
                            placeholder="Dialog Text 4"
                        />
                    </div>
                    <footer>
                        <SecondaryButton
                            disabled={disabled || inProgress}
                            className={css.submitButton}
                            type="submit"
                            ready={ready}
                            inProgress={inProgress}
                        >
                            admin::{action}
                        </SecondaryButton>
                    </footer>
                </Form>
            );
        }}
    />
);
